export const userLanguage = () => {
  const lng = navigator.language || navigator.userLanguage;
  if (lng.includes('es')) return 'es';
  if (lng.includes('en')) return 'en';
  if (lng.includes('fr')) return 'fr';
  if (lng.includes('pt')) return 'pt';
  return 'en';
};
